import {
    faBuilding,
    faEdit,
    faSearch,
    faUser,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import {
    ListarEmpreendimentosController,
    ListarUnidadesByIdEmpreendimentoController,
} from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { IUnidade } from "../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import { MoneyReaisFieldMask } from "../../../../Validations/InputMasks";
import {
    CadastrarVendaController,
    EditarVendaController,
    GetVendaController,
} from "../../../../Controllers/Geral/RegistraVenda/RegistraVendaControllers";
import { getDateNow } from "../../../../Validations/DateValidation";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import { useHistory, useParams } from "react-router-dom";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import moment from "moment";
import { ACESSOS } from "../../../../Routes/Acessos";
import ModalComponent from "../../../../Components/Modais";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import TabelaCliente from "./TabelaCliente";

interface IRegistroVendaForm {
    ID_PRODUTO: number;
    ID_CONTA: number;
    QTD_PRODUTO: number;
    VLR_UNITARIO_PRODUTO: number;
    DT_VENDA: string;
    VLR_TOTAL_PRODUTO: number;
}

const clienteInicial = {
    DS_CONTA: "",
    ID_CONTA: 0,
};
interface RouteParams {
    IdVenda: string;
}

export default function CadastraEEditaVenda() {
    const FormMethods = useForm();
    const params = useParams<RouteParams>();
    const { IdVenda } = params;
    const history = useHistory();

    const [cliente, setCliente] = useState(clienteInicial);
    const [lstUnidades, setLstUnidades] = useState<Array<IUnidade>>();
    const [idProduto, setIdProduto] = useState(0);
    const [show, setShow] = useState(false);
    const [active, setActive] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const { execute: cadastrarVenda, loading: cadastrarLoading } =
        useAsyncCallback(CadastrarVendaController);
    const { execute: editarVenda, loading: editarLoading } = useAsyncCallback(
        EditarVendaController
    );
    function handleCadastrarOuEditarVenda(formData: IRegistroVendaForm) {
        if (!show) {
            const formFormatted = {
                ...formData,
                ID_CONTA: cliente.ID_CONTA,
                FL_STATUS_VENDA: active,
                VLR_TOTAL_PRODUTO:
                    formData.VLR_UNITARIO_PRODUTO * formData.QTD_PRODUTO,
                DT_VENDA:
                    formData.DT_VENDA !== "" ? formData.DT_VENDA : getDateNow(),
            };
            if (venda) {
                editarVenda(formFormatted, Number(IdVenda)).then(() =>
                    history.push(
                        ACESSOS.GERAL.TELAS.REGISTRO_VENDA.LISTAGEM.DS_PATH
                    )
                );
            } else {
                cadastrarVenda(formFormatted).then(() =>
                    history.push(
                        ACESSOS.GERAL.TELAS.REGISTRO_VENDA.LISTAGEM.DS_PATH
                    )
                );
            }
        }
    }

    const { value: venda, loading: vendaLoading } = useAsyncEffect(async () => {
        if (IdVenda) {
            return GetVendaController(Number(IdVenda));
        }
    }, [IdVenda]);

    const { value: listarUnidades, loading: listarUnidadesLoading } =
        useAsyncEffect(async () => {
            if (idProduto !== 0) {
                return ListarUnidadesByIdEmpreendimentoController(idProduto);
            }
        }, [idProduto]);

    useEffect(() => {
        setLstUnidades(listarUnidades);
    }, [listarUnidades]);

    useEffect(() => {
        if (venda) {
            setIdProduto(venda?.ID_EMPREENDIMENTO);
            setCliente({ ID_CONTA: venda?.ID_CONTA, DS_CONTA: venda?.DS_NOME });
        }
    }, [venda]);

    return (
        <FormProvider {...FormMethods}>
            <OrSpinner spinner="capys" loading={vendaLoading}>
                <UnForm
                    usingContext
                    handleSubmit={handleCadastrarOuEditarVenda}
                    className="row justify-content-center mx-2 mt-8"
                >
                    <div className="form-group col-12">
                        <UnForm.LazySelect
                            controller={ListarEmpreendimentosController}
                            getDS={(j) => j.DS_EMPREENDIMENTO}
                            getKeyValue={(j) => j.ID_EMPREENDIMENTO}
                            defaultValue={venda?.ID_EMPREENDIMENTO}
                            registerOptions={{
                                required:
                                    "Selecione o produto",
                            }}
                            name="ID_EMPREENDIMENTO"
                            label="Produto"
                            onChange={(e) =>
                                setIdProduto(Number(e.target.value))
                            }
                        >
                            <option style={{ display: "none" }}></option>
                        </UnForm.LazySelect>
                    </div>
                    {idProduto !== 0 ? (
                        <div className="form-group col-12">
                            <OrSpinner
                                spinner="capys"
                                loading={listarUnidadesLoading}
                            >
                                <UnForm.Select
                                    name="ID_PRODUTO"
                                    label="Unidade"
                                    defaultValue={venda?.ID_UNIDADE}
                                    registerOptions={{
                                        required:
                                            "Selecione a unidade",
                                    }}
                                >
                                    <option></option>
                                    {lstUnidades?.map((unidade) => (
                                        <option
                                            key={unidade.ID_UNIDADE}
                                            value={unidade.ID_UNIDADE}
                                        >
                                            {unidade.DS_UNIDADE}
                                        </option>
                                    ))}
                                </UnForm.Select>
                            </OrSpinner>
                        </div>
                    ) : null}
                    <div className="form-group col-6">
                        <UnForm.Input
                            type="text"
                            name="VLR_UNITARIO_PRODUTO"
                            label="Valor unitário do produto"
                            registerOptions={{
                                setValueAs: (v: string) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                            }}
                            defaultValue={formatMoneyReais(
                                venda?.VLR_UNITARIO_PRODUTO ?? 0
                            )}
                            onChange={MoneyReaisFieldMask}
                        />
                    </div>
                    <div className="form-group col-6">
                        <UnForm.Input
                            type="number"
                            name="QTD_PRODUTO"
                            min={1}
                            defaultValue={venda?.QTD_PRODUTO}
                            label="Quantidade do Produto"
                            registerOptions={{
                                required:
                                    "Insira a quantidade do produto",
                            }}
                        />
                    </div>
                    <div className="form-group col-6">
                        <UnForm.InputButton
                            type="text"
                            name="ID_CONTA"
                            value={cliente.DS_CONTA}
                            label="Cliente"
                            readOnly
                            icon={faSearch}
                            placeholder="Selecione um Cliente"
                            registerOptions={{
                                required:
                                    "Selecione o cliente",
                            }}
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: "Selecionar um Cliente",
                                    IconHeader: faUser,
                                    Component: () => (
                                        <>
                                            <TabelaCliente
                                                setCliente={setCliente}
                                                setShow={setShow}
                                            />
                                        </>
                                    ),
                                    size: "lg",
                                });
                            }}
                        />
                    </div>
                    <div className="form-group col-6">
                        <UnForm.Input
                            type="date"
                            name="DT_VENDA"
                            label="Data da Venda"
                            defaultValue={moment(venda?.DT_VENDA).format(
                                "YYYY-MM-DD"
                            )}
                            registerOptions={{
                                required:
                                    "Informe a data",
                            }}
                        />
                    </div>
                    <div className="form-group col-12">
                        <UnForm.Switch
                            color="success"
                            label="Ativar a venda"
                            name="FL_STATUS_VENDA"
                            type="checkbox"
                            labelPosition="top"
                            defaultChecked={venda?.FL_STATUS_VENDA}
                            onChange={(e) => setActive(e.target.checked)}
                            wrapperClassName="col-12 col-md-12 m-0"
                        />
                    </div>
                    <div className="col-6">
                        <UnForm.SubmitButton
                            outline
                            id="dados_form_submit_button"
                            type="submit"
                            color="success"
                            iconSize="lg"
                            loading={cadastrarLoading || editarLoading}
                            wrapperClassName="col-12 m-0 p-0"
                            loadingSize="sm"
                            className="d-none font-weight-bold col-12 mt-4"
                            icon={venda ? faEdit : faBuilding}
                        >
                            {venda ? "Editar Venda" : "Cadastrar Venda"}
                        </UnForm.SubmitButton>
                    </div>
                </UnForm>
                <ModalComponent
                    ModalComponent={modal}
                    show={show}
                    setShow={setShow}
                />
            </OrSpinner>
        </FormProvider>
    );
}
